/**
 * @flow
 * @relayHash b29de6ff1689465f72751aef12389bf0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgDailyImageInput = {
  userId: string,
  clientMutationId?: ?string,
};
export type SetBackgroundDailyImageMutationVariables = {|
  input: SetUserBkgDailyImageInput
|};
export type SetBackgroundDailyImageMutationResponse = {|
  +setUserBkgDailyImage: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +backgroundImage: ?{|
        +id: string,
        +imageURL: ?string,
        +timestamp: ?string,
      |},
    |}
  |}
|};
export type SetBackgroundDailyImageMutation = {|
  variables: SetBackgroundDailyImageMutationVariables,
  response: SetBackgroundDailyImageMutationResponse,
|};
*/


/*
mutation SetBackgroundDailyImageMutation(
  $input: SetUserBkgDailyImageInput!
) {
  setUserBkgDailyImage(input: $input) {
    user {
      backgroundOption
      backgroundImage {
        id
        imageURL
        timestamp
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgDailyImageInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgDailyImageInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "backgroundOption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "backgroundImage",
  "storageKey": null,
  "args": null,
  "concreteType": "BackgroundImage",
  "plural": false,
  "selections": [
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SetBackgroundDailyImageMutation",
  "id": null,
  "text": "mutation SetBackgroundDailyImageMutation(\n  $input: SetUserBkgDailyImageInput!\n) {\n  setUserBkgDailyImage(input: $input) {\n    user {\n      backgroundOption\n      backgroundImage {\n        id\n        imageURL\n        timestamp\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SetBackgroundDailyImageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgDailyImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgDailyImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v4
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetBackgroundDailyImageMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgDailyImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgDailyImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v4,
              v3
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '50f99e8a8c2ce7d300f7a57c4a15371f';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/SetBackgroundDailyImageMutation.graphql.js